import { createElementBlock as o, openBlock as t, createElementVNode as l } from "vue";
const n = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-download"
};
function r(s, e) {
  return t(), o("svg", n, e[0] || (e[0] = [
    l("path", {
      d: "M8 12.5L3 7.50004L4.4 6.05004L7 8.65004V0.500038H9V8.65004L11.6 6.05004L13 7.50004L8 12.5ZM0 16.5V11.5H2V14.5H14V11.5H16V16.5H0Z",
      fill: "black",
      class: "svg__fill--heading-grey"
    }, null, -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
